export const countryReducer = (state = null, action) => {
  switch (action.type) {
    case "INITIALLOAD":
      const initialCountry = action.payload.countries_stat.filter(
        (item, index) => {
          if (item.country_name == action.countryName) {
            return item;
          }
        }
      );

      return {
        ...state,
        allstats: [...initialCountry],
        allData: [...action.payload.countries_stat],
      };
      break;
    case "SEARCHCOUNTRY":
      const filtercountry = action.payload.countries_stat
        ? action.payload.countries_stat.filter(
            (item) =>
              item.country_name.toLowerCase().trim() ==
              action.query.toLowerCase().trim()
          )
        : null;
      return { ...state, allstats: filtercountry };
      break;

    default:
      return state;
  }
};
